import React, {useEffect, useState} from 'react';
import colors from '../../../../../../util/colors';
import {Icons} from '../../../../../../util/icons';
import {strings} from '../../../../../../util/strings';
import AppButton from '../../../../../app-button';
import Icon from '../../../../../icon';
import './styles.scss';

import {Column, Row} from '../../../../../layout';
import ModalTemplate from '../../../../../modal';
import * as fonts from '../../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import alertQuestion from '../../../../../../assets/alert-question.svg';
import {AppForm, AppFormField, AppFormSubmitButton} from '../../../../../forms';
import * as Yup from 'yup';
import {validateYupSchema} from 'formik';
import {post} from '../../../../../../api/api';
import {
  uriCleanUser,
  uriPostPasswordCheckResult,
} from '../../../../../../api/endpoints';
import {AuthConsumer} from '../../../../../../providers/AuthProvider';
import Logout from '../../../../../auth/logout';
import {useHistory} from 'react-router-dom';

interface ConfirmPasswordModalProps {
  show: any;
  labels: typeof strings.pt.virtualCard;
  setShow(value: any): void;
}

const validationSchema = Yup.object().shape({
  password: Yup.string().required(),
});

function ConfirmPasswordModal({
  show,
  labels,
  setShow,
}: ConfirmPasswordModalProps) {
  const [valid, setValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [generalError, setGeneralError] = useState(false);

  const featureName = 'VirtualCard-ConfirmPassword';

  const handlePasswordIconClick = () => {
    setViewPassword(!viewPassword);
  };
  const history = useHistory();

  const onSubmit = async (values: any, logout: any) => {
    localStorage.setItem('redirectToRegister', 'true');
    setWrongPassword(false);
    setGeneralError(false);
    setSubmitting(true);
    const body = {
      password: values.password,
    };
    try {
      await post(
        uriPostPasswordCheckResult(),
        JSON.stringify(body),
        false,
        featureName
      );

      try {
        await post(uriCleanUser(), {}).then((res) => {
          logout();
        });
      } catch {
        setGeneralError(true);
      }
    } catch {
      setWrongPassword(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalTemplate
      hideFooter={true}
      cross={true}
      centered={false}
      show={show}
      className="confirm-password-modal"
      title={labels?.changeInsurance_wishToContinue_title}
      titleStyle={{...fonts.L, ...fonts.SemiBold}}
      onHide={() => {
        setShow(false);
        setGeneralError(false);
        setWrongPassword(false);
      }}
      size="lg">
      <AuthConsumer>
        {({logout}) => (
          <>
            <Row>
              <img className="alert-question" src={alertQuestion} />
            </Row>
            <Column
              className="data-not-found-description"
              style={{
                ...fonts.MM,
                ...fonts.Medium,
                color: colors.alertRed,
              }}>
              {labels?.changeInsurance_wishToContinue_question}
            </Column>
            <Row>
              <span
                className="insert-password-modal-description"
                style={{...fonts.MM, ...fonts.Light}}>
                {labels?.changeInsurance_wishToContinue_text}
              </span>
            </Row>
            <Row className="app-form-confirm-password-container-row">
              <AppForm
                initialValues={{
                  dob: '',
                  buId: '',
                  cardNumber: '',
                }}
                className="app-form-container"
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  onSubmit(values, logout);
                }}
                onValidation={(valid) => setValid(valid)}>
                <Row className="confirm-password-field-row">
                  <AppFormField
                    name="password"
                    type={viewPassword ? '' : 'password'}
                    className="confirm-password-field"
                    placeholder={labels?.changeInsurance_password_placeholder}
                    showPassword={viewPassword}
                    passwordIcon={true}
                    handlePasswordIconClick={handlePasswordIconClick}
                  />
                </Row>
                {wrongPassword && (
                  <Row
                    className="wrong-password-error-text"
                    style={{
                      ...fonts.M,
                      ...fonts.SemiBold,
                      color: colors.alertRed,
                    }}>
                    {labels?.changeInsurance_wishToContinue_errorPassword}
                  </Row>
                )}
                {generalError && (
                  <Row
                    className="wrong-password-error-text"
                    style={{
                      ...fonts.M,
                      ...fonts.SemiBold,
                      color: colors.alertRed,
                    }}>
                    {`${labels?.changeInsuranceData_generalErrorOcurred} ${labels?.changeInsuranceData_generalErrorTryAgain}`}
                  </Row>
                )}
                <Row>
                  <Column className="cancel-column">
                    <AppButton
                      className="confirm-password-cancel-button"
                      variant="secondary"
                      onClick={() => {
                        setShow(false);
                        setGeneralError(false);
                        setWrongPassword(false);
                      }}>
                      {labels?.changeInsurance_wishToContinue_cancelButton}
                    </AppButton>
                  </Column>
                  <Column className="submit-column">
                    <AppFormSubmitButton
                      title={labels?.changeInsurance_wishToContinue_okButton}
                      variant="secondary"
                      disabled={!valid || submitting}
                      className="confirm-password-submit-button"
                    />
                  </Column>
                </Row>
              </AppForm>
            </Row>
          </>
        )}
      </AuthConsumer>
    </ModalTemplate>
  );
}

const mapStateToProps = ({stringsDefault}: any) => ({
  labels: stringsDefault.value.pt.virtualCard,
});

export default compose(connect(mapStateToProps)(ConfirmPasswordModal));
